import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../css/Availability.css"; // Import CSS file for styling
import { FaPlus, FaTrash } from "react-icons/fa";
import { GetInSeconds } from "../../_helper/utils.js/utils";
import {
    useCreateItem,
    useDeleteItem,
    useUpdateItem,
} from "../../../_helper/actions/mutation/items";
import { formatSecondsToHHMM } from "../../_helper/utils.js/utils";
import { clinicAtom } from "../../../_helper/constant/constant-atom";
import { useCurrentRole } from "../../../_helper/constant/Permission";
import { useAtom } from "jotai";
import { ApiEndPoint } from "../../../_helper/constant/api-types";
import { useItemsFilter } from "../../../_helper/actions/app/items";
import { RiEdit2Fill } from "react-icons/ri";
import moment from "moment";
import CuModal from "../../../common_component/component/CuModal";
import Confirmation from "../../../common_component/component/Confirmation";
import CuButton from "../../../all-patient/components/CuButton";
import CuInput from "../../../all-patient/components/CuInput";

export const AvailableForm = () => {
    const [formData, setFormData] = useState({
        id: "",
        session_name: "",
        consultation_fees: "",
        duration: "",
        selected_days: [],
        start_time: "",
        end_time: "",
    });

    const darkGreyColorStyle = { backgroundColor: "var(--darkgrey-color)" };

    const [openDelete, setOpenDelete] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState("");
    const postAvailabilityMutation = useCreateItem(ApiEndPoint?.CLINIC);

    const updateMutation = useUpdateItem(ApiEndPoint?.CLINIC);

    const useDeleteMutation = useDeleteItem(ApiEndPoint?.CLINIC);

    const [clinic_id] = useAtom(clinicAtom);

    const { role_id, isLoading: roleLoading } = useCurrentRole();

    const queryString = `?action=getAvailability&clinic_id=${clinic_id?.id}&frontend=True&doctor_id=${role_id}`;

    const { data: data } = useItemsFilter(
        ApiEndPoint?.CLINIC,
        queryString,
        clinic_id?.id ? true : false
    );

    const secondsToMinutes = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const secondsRemaining = seconds % 60;
        const formattedMinutes = String(minutes).padStart(2, "0");
        const formattedSeconds = String(secondsRemaining).padStart(2, "0");
        return `${formattedMinutes}`;
    };

    const handleOpenDelete = (index) => {
        setSelectedIndex(index);
        setOpenDelete(true);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (formData?.id) {
            const payload = {
                id: formData?.id,
                action: "patchAvailability",
                slot_types: [],
                backend: "True",
                consultation_fees: formData?.consultation_fees,
                qm_sc_fields: [],
                selected_days: formData?.selected_days,
                session_name: formData?.session_name,
                duration: Number(formData?.duration) * 60,
                sort: 2,
                start_time: GetInSeconds(formData?.start_time),
                end_time: GetInSeconds(formData?.end_time),
                status: "open",
                type: "bgf",
                clinic_id: clinic_id?.id,
                doctor_user: role_id,
                persona: 1,
                visibility: 1,
            };

            updateMutation.mutate(
                {
                    data: payload,
                },
                {
                    onSuccess: (data) => {
                        toast.success("Updated successfully!");
                        setFormData({
                            id: "",
                            session_name: "",
                            consultation_fees: "",
                            duration: "",
                            selected_days: [],
                            start_time: "",
                            end_time: "",
                        });
                    },
                    onError: (error) => {
                        if (error.response.data.msg) {
                            toast.error(error.response.data.msg);
                        } else {
                            toast.error(JSON.stringify(error.response.data));
                        }
                    },
                }
            );
        } else {
            const payload = {
                action: "postAvailability",
                slot_types: [],
                backend: "True",
                qm_sc_fields: [],
                selected_days: formData?.selected_days,
                consultation_fees: formData.consultation_fees,
                session_name: formData?.session_name,
                duration: Number(formData.duration) * 60,
                sort: 2,
                start_time: GetInSeconds(formData.start_time),
                end_time: GetInSeconds(formData.end_time),
                status: "open",
                type: "bgf",
                clinic_id: clinic_id?.id,
                doctor_user: role_id,
                persona: 1,
                visibility: 1,
            };

            if (formData) {
                postAvailabilityMutation.mutate(payload, {
                    onSuccess: (data) => {
                        toast.success("Availability created successfully!");
                    },
                    onError: (error) => {
                        if (error.response.data.msg) {
                            toast.error(error.response.data.msg);
                        } else {
                            toast.error(JSON.stringify(error.response.data));
                        }
                    },
                });
            }
        }
    };

    const handleDeleteClick = () => {
        const sessionData = data[selectedIndex];

        const payload = {
            action: "delAvailability",
            id: sessionData.id,
            backend: "True",
            clinic_id: clinic_id?.id,
        };

        if (sessionData.id) {
            useDeleteMutation.mutate(
                {
                    data: payload,
                },
                {
                    onSuccess: (data) => {
                        toast.success("Availbility deleted successfully!");
                        setOpenDelete(false);
                        setSelectedIndex("");
                    },
                    onError: (error) => {
                        if (error.response.data.msg) {
                            toast.error(error.response.data.msg);
                        } else {
                            toast.error(JSON.stringify(error.response.data));
                        }
                    },
                }
            );
        }
    };

    const formatSelectedDays = (days) => {
        const dayMap = {
            monday: "Mon",
            tuesday: "Tue",
            wednesday: "Wed",
            thursday: "Thu",
            friday: "Fri",
            saturday: "Sat",
            sunday: "Sun",
        };
        return days.map((day) => dayMap[day.toLowerCase()]).join(", ");
    };

    const buttonStyle = {
        backgroundColor: "#C7EAC9",
        color: "#000000",
        border: "none",
        borderRadius: "4px",
        padding: "13px",
        fontSize: "16px",
        width: "200px",
        cursor: "pointer",
        fontWeight: "400",
    };

    const [days, setDays] = useState([
        { name: "M", value: "monday", active: false },
        { name: "T", value: "tuesday", active: false },
        { name: "W", value: "wednesday", active: false },
        { name: "T", value: "thursday", active: false },
        { name: "F", value: "friday", active: false },
        { name: "S", value: "saturday", active: false },
        { name: "S", value: "sunday", active: false },
    ]);

    const handleEditClick = (data) => {
        setFormData({
            id: data?.id,
            session_name: data?.session_name,
            consultation_fees: data?.consultation_fees,
            duration: secondsToMinutes(data?.duration),
            selected_days: data?.selected_days,
            start_time: formatSecondsToHHMM(data?.start_time),
            end_time: formatSecondsToHHMM(data?.end_time),
        });
    };

    return (
        <>
            <div
                className="form_items"
                style={{
                    display: "flex",
                    alignItems: "start",
                    gap: "10%",
                    flexWrap: "wrap",

                    flex: "1",
                }}>
                <div style={{ backgroundColor: "white", padding: "20px" }}>
                    <form onSubmit={handleSubmit}>
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                marginBottom: "20px",
                                gap: "5px",
                            }}>
                            <div className="w-[180px] text-xl">
                                <input
                                    value={formData?.session_name}
                                    className="border rounded w-full text-xl px-1 py-1 outline-none"
                                    id="Session"
                                    onChange={(e) => {
                                        setFormData({
                                            ...formData,
                                            session_name: e.target.value,
                                        });
                                    }}
                                    placeholder="Session name"
                                />
                            </div>
                        </div>

                        <div className="flex w-[450px] gap-4">
                            <div className="flex-1">
                                <label>
                                    Consultation Fees{" "}
                                    <span style={{ color: "red" }}>*</span>
                                </label>
                                <CuInput
                                    type={`number`}
                                    required
                                    placeholder="Fees"
                                    id="consultation_fees"
                                    value={formData.consultation_fees}
                                    onChange={(e) => {
                                        setFormData({
                                            ...formData,
                                            consultation_fees: e.target.value,
                                        });
                                    }}
                                />
                            </div>
                            <div className="flex-1">
                                <label>
                                    Consultation Duration{" "}
                                    <span style={{ color: "red" }}>*</span>{" "}
                                </label>
                                <CuInput
                                    placeholder="Duration"
                                    type={`number`}
                                    required
                                    value={formData?.duration}
                                    id="duration"
                                    onChange={(e) => {
                                        setFormData({
                                            ...formData,
                                            duration: e.target.value,
                                        });
                                    }}
                                    className="w-full border border-gray-300 rounded px-2 py-2"
                                />
                            </div>
                        </div>

                        <div className="my-4">
                            <div
                                style={{
                                    display: "flex",
                                    gap: "10px",
                                    alignItems: "center",
                                    flexWrap: "wrap",
                                }}>
                                {days.map((day) => (
                                    <label
                                        key={day.value}
                                        className="button-checkbox">
                                        <input
                                            type="checkbox"
                                            checked={formData?.selected_days?.includes(
                                                day.value
                                            )}
                                            onChange={(e) => {
                                                const isChecked =
                                                    e.target.checked;
                                                if (isChecked) {
                                                    setFormData(
                                                        (prevFormData) => ({
                                                            ...prevFormData,
                                                            selected_days: [
                                                                ...prevFormData.selected_days,
                                                                day.value,
                                                            ],
                                                        })
                                                    );
                                                } else {
                                                    setFormData(
                                                        (prevFormData) => ({
                                                            ...prevFormData,
                                                            selected_days:
                                                                prevFormData.selected_days.filter(
                                                                    (
                                                                        selectedDay
                                                                    ) =>
                                                                        selectedDay !==
                                                                        day.value
                                                                ),
                                                        })
                                                    );
                                                }
                                            }}
                                            style={{ display: "none" }}
                                        />
                                        <span className="checkbox-label">
                                            {day.name}
                                        </span>
                                    </label>
                                ))}
                            </div>
                        </div>

                        <div className="flex w-[450px] gap-4">
                            <div className="flex-1">
                                <label>
                                    Start Time{" "}
                                    <span style={{ color: "red" }}>*</span>
                                </label>
                                <CuInput
                                    type="time"
                                    required
                                    id="start_time"
                                    value={formData?.start_time}
                                    onChange={(e) => {
                                        setFormData({
                                            ...formData,
                                            start_time: e.target.value,
                                        });
                                    }}
                                    className="w-full border border-gray-300 rounded px-2 py-2"
                                />
                            </div>
                            <div className="flex-1">
                                <label>
                                    End Time{" "}
                                    <span style={{ color: "red" }}>*</span>
                                </label>
                                <CuInput
                                    type="time"
                                    id="end_time"
                                    required
                                    value={formData?.end_time}
                                    onChange={(e) => {
                                        setFormData({
                                            ...formData,
                                            end_time: e.target.value,
                                        });
                                    }}
                                    className="w-full border border-gray-300 rounded px-2 py-2"
                                />
                            </div>
                        </div>

                        <div className="flex my-4 gap-4">
                            <CuButton
                                onClick={() =>
                                    setFormData({
                                        id: "",
                                        session_name: "",
                                        consultation_fees: "",
                                        duration: "",
                                        selected_days: [],
                                        start_time: "",
                                        end_time: "",
                                    })
                                }
                                className="w-full text-black rounded py-2 flex-1"
                                style={{
                                    ...buttonStyle,
                                    // darkGreyColorStyle,
                                    backgroundColor: "#CDCDCD",
                                }}>
                                Cancel
                            </CuButton>
                            <CuButton
                                className="w-full text-black rounded py-2 flex-1"
                                style={buttonStyle}
                                type="submit"
                                isLoading={
                                    updateMutation.isLoading ||
                                    postAvailabilityMutation.isLoading
                                }>
                                Set
                            </CuButton>
                        </div>
                    </form>
                </div>
            </div>
            <div className="cu-setup-table mt-5">
                <table>
                    <thead className="cu-setup-table-header">
                        <tr>
                            <th>Name</th>
                            <th>Consultation Fees</th>
                            <th>Consultation Duration</th>
                            <th>Start Time</th>
                            <th>End Time</th>
                            <th>Availability Days</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data?.map((item, i) => {
                            const selectedDays = formatSelectedDays(
                                item?.selected_days
                            );
                            return (
                                <tr key={i}>
                                    <td>{item?.session_name || "N/A"}</td>
                                    <td>{item?.consultation_fees}</td>
                                    <td>{secondsToMinutes(item.duration)}</td>
                                    <td>
                                        {formatSecondsToHHMM(item?.start_time)}
                                    </td>
                                    <td>
                                        {formatSecondsToHHMM(item?.end_time)}
                                    </td>
                                    <td>{selectedDays}</td>
                                    <td>
                                        <div className="cu-setup-table-action-col">
                                            <RiEdit2Fill
                                                size={18}
                                                className="cursor-pointer"
                                                onClick={() =>
                                                    handleEditClick(item)
                                                }
                                            />
                                            <FaTrash
                                                size={16}
                                                className="cursor-pointer"
                                                onClick={() =>
                                                    handleOpenDelete(i)
                                                }
                                            />
                                        </div>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
            {openDelete && (
                <CuModal closeModal={() => setOpenDelete(false)}>
                    <Confirmation
                        heading={`Delete this availability`}
                        onCancel={() => setOpenDelete(false)}
                        onClick={handleDeleteClick}
                        loading={useDeleteMutation.isLoading}
                    />
                </CuModal>
            )}
        </>
    );
};
